import { Filters } from '../interfaces';

export enum TransacionesActionType {
  GET_TRANSACTIONS = 'TRANSACTIONS/GET_TRANSACTIONS',
  GET_TRANSACTIONS_SUCCESS = 'TRANSACTIONS/GET_TRANSACTIONS_SUCCESS',
  GET_TRANSACTIONS_ERROR = 'TRANSACTIONS/GET_TRANSACTIONS_ERROR',
  GET_PAYMENT_METHODS_FOR_TRANSACTIONS = 'TRANSACTIONS/GET_PAYMENT_METHODS_FOR_TRANSACTIONS',
  GET_PAYMENT_METHODS_FOR_TRANSACTIONS_SUCCESS = 'TRANSACTIONS/GET_PAYMENT_METHODS_FOR_TRANSACTIONS_SUCCESS',
  GET_PAYMENT_METHODS_FOR_TRANSACTIONS_ERROR = 'TRANSACTIONS/GET_PAYMENT_METHODS_FOR_TRANSACTIONS_ERROR',
  SHOW_EXPORT_TRANSACTIONS = 'TRANSACTIONS/SHOW_EXPORT_TRANSACTIONS',
  EXPORT_TRANSACTIONS = 'TRANSACTIONS/EXPORT_TRANSACTIONS',
  EXPORT_TRANSACTIONS_SUCCESS = 'TRANSACTIONS/EXPORT_TRANSACTIONS_SUCCESS',
  EXPORT_TRANSACTIONS_ERROR = 'TRANSACTIONS/EXPORT_TRANSACTIONS_ERROR',
}

export const getTransactions = (page?: number, filter?: Filters) => ({
  type: TransacionesActionType.GET_TRANSACTIONS,
  page,
  filter,
});

export const getTransactionsSuccess = (response: any) => ({
  type: TransacionesActionType.GET_TRANSACTIONS_SUCCESS,
  response,
});

export const getTransactionsError = (error: any) => ({
  type: TransacionesActionType.GET_TRANSACTIONS_ERROR,
  error,
});

export const getPaymentMethodsForTrans = (country: string) => ({
  type: TransacionesActionType.GET_PAYMENT_METHODS_FOR_TRANSACTIONS,
  country,
});

export const getPaymentMethodsForTransSuccess = (response: any) => ({
  type: TransacionesActionType.GET_PAYMENT_METHODS_FOR_TRANSACTIONS_SUCCESS,
  response,
});

export const getPaymentMethodsForTransError = (error: any) => ({
  type: TransacionesActionType.GET_PAYMENT_METHODS_FOR_TRANSACTIONS_ERROR,
  error,
});

export const showExportTransactions = (show: boolean) => ({
  type: TransacionesActionType.SHOW_EXPORT_TRANSACTIONS,
  show,
});

export const exportTransactions = (filter: string) => ({
  type: TransacionesActionType.EXPORT_TRANSACTIONS,
  filter,
});

export const exportTransactionsSuccess = (response: any) => ({
  type: TransacionesActionType.EXPORT_TRANSACTIONS_SUCCESS,
  response,
});

export const exportTransactionsError = (error: any) => ({
  type: TransacionesActionType.EXPORT_TRANSACTIONS_ERROR,
  error,
});
